// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"B1-z","colorTextValue":"C1-z","swatches":"D1-z","collapseLink":"E1-z","isCollapsed":"F1-z","dropdown":"G1-z","disabled":"H1-z"};